"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleOffline = void 0;

/* eslint-disable */

/**
 * TODO: 
 * 
 * @param {*} offlineAction 
 */
var handleOffline = function handleOffline(offlineAction) {
  var showModalIfOffline = function showModalIfOffline(onlineAction) {
    if (!navigator.onLine) {
      offlineAction();
    } else {
      onlineAction();
    }
  };

  return showModalIfOffline;
};

exports.handleOffline = handleOffline;